import React, { useState,useEffect } from 'react';
import Button from '../Button/Button';
import ItemPlace from './ItemPlace/ItemPlace';
import './GamePage.css';

const GamePage = (props) => {
    const [curWord, setCurWord] = useState('');
    const [curImg, setCurImg] = useState('');


    useEffect(() => {
        setCurWord('');
    }, [props.letter]);

    const handleAnswer = ((pri,index) => {
        
        setCurImg(<img src={props.imagesArr[props.curWords[index].key].src} alt='' />);
        setCurWord(props.curWords[index]);
        props.onClick('downImg', pri, index)
    });

    const imgesWords = props.curWords.map((items, kol) =>
        <ItemPlace key={items.key} className={'Place' + items.place} src={props.imagesArr[items.key].src} onClick={() => handleAnswer(items.place, kol)} />
       );
                  
      
    let letterStyle = 'letterPlace';
    let wordStyle = 'GamesWord';
    if (props.fontStyle === "1") letterStyle = 'letterPlace glasnyi';
    else {
        if (props.fontStyle === "2") {
            letterStyle = 'letterPlace soglasnyi';
            wordStyle = 'GamesWord firstLetterSoglasnyi';
        }
    }

     return (
           <div>
                {imgesWords}
             <div className='gameCircle'>  </div>
             <div className={letterStyle} style={(props.letter === 'Д') ? { fontSize: 180 } : { fontSize: 200 }}>{props.letter}</div>
                <div className={wordStyle}> {curWord.word}</div>

                <div className='bigImg' hidden={props.disabled} > {curImg} </div>
                <Button className='GamePrev' onClick={() => props.onClick('prev')} /> 
                <Button className='GameNext' onClick={() => props.onClick('next')} /> 
        </div>
    );
    };

export default GamePage;